import React from 'react';
import { Button } from 'react-bootstrap';

interface LomavisButtonWithIconProps {
    iconClass: string; // e.g., 'fa-duotone fa-plus'
    text: string;
    onClickHandler: () => void;
    variant?: string;
    size?: 'sm' | 'lg';
    disabled?: boolean;
    className?: string;
    type?: 'button' | 'submit' | 'reset';
}

export const LomavisButtonWithIcon: React.FC<LomavisButtonWithIconProps> = ({
                                                                                iconClass,
                                                                                text,
                                                                                onClickHandler,
                                                                                variant = 'primary',
                                                                                size,
                                                                                disabled = false,
                                                                                className = '',
                                                                                type = 'button'
                                                                            }) => {
    return (
        <Button
            variant={variant}
            size={size}
            disabled={disabled}
            className={className}
            onClick={onClickHandler}
            type={type}
        >
            <i className={`${iconClass} me-2`} />
            {text}
        </Button>
    );
};
